exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n[data-v-34c5a7d6] .el-button{margin:0;border-color:#c3c3c3\n}\n[data-v-34c5a7d6] .el-button.selecionado{background:#009f61;border:0;color:#FFFFFF;font-weight:600\n}\n", "", {"version":3,"sources":["/builds/youx-group/sicarf/sicarf-parametrizavel/frontend/src/screens/relatorios_ouvidoria/components/BotaoSelecionar.vue"],"names":[],"mappings":";AA8CA,6BACE,SACA,oBAAqB;CAFvB;AAAA,yCAKI,mBACA,SACA,cACA,eAAgB;CACjB","file":"BotaoSelecionar.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/deep/ .el-button {\n  margin: 0;\n  border-color: #c3c3c3;\n\n  &.selecionado {\n    background: #009f61;\n    border: 0;\n    color: #FFFFFF;\n    font-weight: 600;\n  }\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-34c5a7d6","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/screens/relatorios_ouvidoria/components/BotaoSelecionar.vue
// module id = vD7W
// module chunks = 12